<template>
    <div class="btn-loading">
        <VueSpinnerIos size="24" color="#000" />
    </div>
</template>


<script>

export default {
    data() {
        return {

            loading: false
        };
    },
    methods: {

    }
};
</script>
<style scoped>
.btn-loading {
    position: absolute;
    /* อยู่ในกรอบของ .main */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.715);
    /* semi-transparent */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}
</style>
